import { render, staticRenderFns } from "./GridMenu.vue?vue&type=template&id=b45025a6"
import script from "./GridMenu.vue?vue&type=script&lang=js"
export * from "./GridMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports